import React, { useState } from 'react';
import Style from './FinanciamentoDeMotos25Blog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function FinanciamentoDeMotos25Blog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="boleto-conteudos">
        <ContainerHome24>
          <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2>
          <div className="is-mobi">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/tudo-que-voce-precisa-saber-antes-de-comprar-sua-moto.html"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source
                          type="image/webp"
                          srcSet="static/amp/blog/post-7/motos-corpo-texto.webp"
                        />
                        <source
                          type="image/jpg"
                          srcSet="static/amp/blog/post-7/motos-corpo-texto.jpg"
                        />
                        <img
                          src="static/amp/blog/post-7/motos-corpo-texto.jpg"
                          alt="homem sentado sobre uma moto preta apertando a mãos do vendedor fechando a compra da moto"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Tudo o que você precisa saber antes de comprar sua moto
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/financiamento-de-motos-dicas-para-evitar-problemas-e-economizar.html"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-29/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-29/capa.jpg" />
                        <img
                          src="static/amp/blog/post-29/capa.jpg"
                          alt="Mulher indicando um veículo a um homem que observa demonstrando felicidade em conseguir fazer um financiamento de motos."
                        />
                      </picture>
                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Financiamento de motos: dicas para evitar problemas e economizar
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a href="blog/seguro-auto.html" className="boleto-conteudos-card">
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-14/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-14/capa.png" />
                        <img
                          src="static/amp/blog/post-14/capa.png"
                          alt="Casal de homem e mulher sentados no porta malas de um veiculo prata, segurando uma criança no colo. O veiculo está parado em uma estrada de terra com gramado verde em volta."
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Proteja seu veículo com o seguro auto
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <div className="cards-desk">
              <a
                href="blog/tudo-que-voce-precisa-saber-antes-de-comprar-sua-moto.html"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source
                    type="image/webp"
                    srcSet="static/amp/blog/post-7/motos-corpo-texto.webp"
                  />
                  <source type="image/jpg" srcSet="static/amp/blog/post-7/motos-corpo-texto.jpg" />
                  <img
                    src="static/amp/blog/post-7/motos-corpo-texto.jpg"
                    alt="homem sentado sobre uma moto preta apertando a mãos do vendedor fechando a compra da moto"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Tudo o que você precisa saber antes de comprar sua moto
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/financiamento-de-motos-dicas-para-evitar-problemas-e-economizar.html"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-29/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-29/capa.jpg" />
                  <img
                    src="static/amp/blog/post-29/capa.jpg"
                    alt="Mulher indicando um veículo a um homem que observa demonstrando felicidade em conseguir fazer um financiamento de motos."
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Financiamento de motos: dicas para evitar problemas e economizar
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a href="blog/seguro-auto.html" className="boleto-conteudos-card">
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-14/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-14/capa.png" />
                  <img
                    src="static/amp/blog/post-14/capa.png"
                    alt="Casal de homem e mulher sentados no porta malas de um veiculo prata, segurando uma criança no colo. O veiculo está parado em uma estrada de terra com gramado verde em volta."
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Proteja seu veículo com o seguro auto
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default FinanciamentoDeMotos25Blog;
